import UnitBrandList from "./UnitBrandList";

const UnitBrandSetupPage = () => <UnitBrandList />;

export default UnitBrandSetupPage;
